import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class DeleteImageApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productImage/image-delete',
      requesterInfo,
    })
  }

  public async deleteImage(prodId: number, imageId: number): Promise<any> {
    this.props.url = `${this.props.url}?prodId=${prodId}&imageId=${imageId}`
    return await this.postAsync<any>()
  }
}
